var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("tool-bar", { attrs: { title: "Add Service Log" } }),
      _vm._v(" "),
      _c(
        "v-container",
        { class: { "px-0 pt-0": _vm.isMobile } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticStyle: { padding: "0" } },
                [
                  _c(
                    "v-tabs",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        slot: "extension",
                        "show-arrows": "",
                        color: "cyan"
                      },
                      slot: "extension"
                    },
                    [
                      _c("v-tabs-slider", { attrs: { color: "yellow" } }),
                      _vm._v(" "),
                      _vm._l(_vm.studentsArray, function(student, index) {
                        return _c(
                          "v-tab",
                          { key: index, attrs: { disabled: index !== 0 } },
                          [
                            _c(
                              "span",
                              {
                                class: {
                                  "yellow--text font-weight-black": index === 0
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(student.studentName) +
                                    "\n              "
                                ),
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.onRemoveStudentClicked(
                                          student
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: {
                                          disabled: !_vm.showTooltip,
                                          top: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            class: {
                                              "yellow--text": _vm.tab === index
                                            },
                                            attrs: {
                                              slot: "activator",
                                              "pl-3": ""
                                            },
                                            slot: "activator"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    clear\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Remove Student")])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-alert", { attrs: { value: _vm.errorMsg, type: "error" } }, [
                _vm._v("\n        " + _vm._s(_vm.errorMsg) + "\n      ")
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticStyle: { padding: "0" } },
                [
                  _c(
                    "v-tabs-items",
                    {
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    _vm._l(_vm.studentsArray, function(student, index) {
                      return _c(
                        "v-tab-item",
                        { key: index },
                        [
                          _c("student-card", { attrs: { student: student } }),
                          _vm._v(" "),
                          _c(
                            "v-form",
                            { attrs: { novalidate: "" } },
                            [
                              _c("sl-stepper", {
                                attrs: {
                                  student: student,
                                  index: index,
                                  loadData: _vm.loadData,
                                  arrayLength: _vm.studentsArray.length,
                                  needLevelArray: _vm.needLevelArray,
                                  deliveryModeArray: _vm.deliveryModeArray,
                                  medicaidArray: _vm.medicaidArray,
                                  showTooltip: _vm.showTooltip,
                                  resetValidations: _vm.resetValidations
                                },
                                on: {
                                  "remove:student": function($event) {
                                    return _vm.onRemoveStudentClicked(student)
                                  },
                                  "form:submitted": function($event) {
                                    _vm.submitted = true
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showLoading ? _c("div", [_c("loading-component")], 1) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-571365d7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-571365d7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-log/form/create-service-log/create-service-log.vue
// module id = null
// module chunks = 